import { createContext, useState } from "react";

export const ActionJobContext = createContext({});

export const Provider = (props) => {
    const { children } = props;

    const [actionJobs, setActionJobs] = useState([]);
    const [cronDialog, setCronDialog] = useState(false);
    const [actionJob, setActionJob] = useState(null);
    const [index, setIndex] = useState(-1);

    // Make the context object:
    const actionJobContext = {
        actionJobs,
        setActionJobs,
        cronDialog,
        setCronDialog,
        actionJob,
        setActionJob,
        index,
        setIndex,
    };

    // pass the value in provider and return
    return <ActionJobContext.Provider value={actionJobContext}>{children}</ActionJobContext.Provider>;
};

export const { Consumer } = ActionJobContext;
